export const categories = [
  { id: "massage", label: "Massage Therapy" },
  { id: "body-treatments", label: "Body Treatments" },
];

export const products = {
  massage: [
    { id: "swedish-massage", name: "Swedish Massage", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: true },
  ],
  "body-treatments": [
    { id: "body-wrap", name: "Body Wrap", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: true },
  ],
};